import { render, staticRenderFns } from "./zh.vue?vue&type=template&id=298f2659"
import script from "./zh.vue?vue&type=script&lang=js"
export * from "./zh.vue?vue&type=script&lang=js"
import style0 from "./zh.vue?vue&type=style&index=0&id=298f2659&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports